module.exports = __webpack_public_path__ + "img/cinnamon-rolls-in-schaal.23b9b1bb.jpg";